const emailRe =
  /^([\w-+]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

export const validateEmail = (email: string) => {
  return emailRe.test(email);
};
